/**
 * @Author: zangkang
 * @Date:   2018-02-06T15:50:18+08:00
 * @Last modified by:   zangkang
 * @Last modified time: 2018-02-06T15:50:18+08:00
 */

import _util from '../../utils/';

const staffBirthdayService = {
	fetchStaffBirthdayList (params, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/BirthdayList',
            params: params,
            success: resolve,
            error: reject
        })
    },

    exportStaffBirthdayList (data, resolve, reject) {
        _util.request({
            url: '/api/HREmployee/ExportBirthdayList',
            data: data,
            success: resolve,
            error: reject
        })
    },
}


export default staffBirthdayService;


// WEBPACK FOOTER //
// ./src/services/EmployeeManagement/staff-birthday-service.js